import { useContext } from 'react'
import { FetchContext } from '../providers/FetchProvider'

export const useFetchContext = () => useContext(FetchContext)
